module.exports = __webpack_public_path__ + "static/media/movies-selected.c12f5084.svg";